document.addEventListener("deviceready", function() {
  if(!window.ga) {
    return;
  }

  window.ga.startTrackerWithId('UA-55924725-2', 30)
  window.ga.setAppVersion('1.4.0');
  window.ga.trackView('App Loaded');

}, false);

export function trackView(screenTitle) {

  // on mobile
  if(window.ga && window.ga.trackView) {
    console.log("tracking -2", screenTitle);
    window.ga.trackView(screenTitle, window.location.hash.replace("#", "/"));
  }

  // in a browser
  else {
    console.log("tracking -1", screenTitle);
    // visitor.screenview(screenTitle).send();
    window.ga('send', 'pageview', window.location.hash.replace("#", "/"));
  }
}


// WEBPACK FOOTER //
// ./src/services/analytics.js